import React from 'react'
import Box from '@mui/material/Box'
import Paper from "@mui/material/Paper"
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import DeleteIcon from '@mui/icons-material/Delete'
import CircularProgress from "@mui/material/CircularProgress"

import { useDropzone } from 'react-dropzone'

import {Context as AppContext} from '../../contexts/App'
import {Context as SalesChannelContext} from '../../contexts/SalesChannels'
import {Context as NotificationsContext} from '../../contexts/Notifications'
import VendorPicker  from '../../components/vendorPicker'
import WarehousePicker  from '../../components/warehousePicker'
import config from '../../config.json'

const failedDownloadSnack = "SalesChannelsShippments-failedDownloadSnack"

const SalesChannelsShippments = () => {
	const app = React.useContext(AppContext)
	const { vendor } = app
	const { warehouse } = app.warehouses
	const { events } = React.useContext(SalesChannelContext)
	const { createSnack, openSnack, deleteSnack } = React.useContext(NotificationsContext)
	const [disabled, setDisabled] = React.useState(false)
	const [file, setFile] = React.useState(false)

	const clear = (e) => {
		e && e.stopPropagation()
		amazonDZ.acceptedFiles.splice(0, 1)
		mercadoDZ.acceptedFiles.splice(0, 1)
		setFile(false)
	}
	
	const drop = acceptedFiles => setFile(acceptedFiles[0].path)
	const amazonDZ = useDropzone({ onDrop: React.useCallback(drop, []), accept: '.csv' })
	const mercadoDZ = useDropzone({ onDrop: React.useCallback(drop, []), accept: '.xlsx' })
	
	const downloadFile = (res) => {
		console.log("downloading file: ", config.api_url+res)
		window.open(config.api_url+res, "_blank")
		setDisabled(false)
	}

	const onError = () => {
		setDisabled(false)
		openSnack(failedDownloadSnack)
	}

	const submitFile = e => {
		const { acceptedFiles } = (vendor == 'amazon'?amazonDZ:mercadoDZ)
		e.stopPropagation()
		setDisabled( true)
		const data = new FormData()
		data.append('vendor', vendor)
		data.append('warehouse', warehouse)
		data.append("salesChannelShippments", acceptedFiles[0])
		events.registerShippments(data, downloadFile, onError)
	}
	React.useEffect(() => {
		createSnack(failedDownloadSnack, {message: "Falló el registro de envíos a canal de venta"})
		return () => deleteSnack(failedDownloadSnack)
	}, [])
	React.useEffect(clear, [vendor])
	
	return (
		<div style={{
			display: 'flex',
			justifyContent: "center",
			margin: 'auto',
			width: 400,
			flexWrap: 'wrap',
		}}>
			<div style={{ width: '100%', float: 'left' }}>
				<h3>Subir reporte de pagos</h3> <br />
			</div>


			<Paper sx={{ cursor: file?'auto':'pointer', position: 'relative', minWidth:"200px", minHeight: '200px', display: "flex", justifyContent: "space-around", alignItems: "center", flexDirection: "column",padding: "15px"}}>
				<VendorPicker/>
				<WarehousePicker/>
				<Box sx={{display:warehouse && vendor=='amazon'?'block':'none'}} {...amazonDZ.getRootProps()}>
					<input {...amazonDZ.getInputProps()} />
					{file && 
						<IconButton sx={{position: 'absolute', top:0, right:0}} tooltip="Quitar archivo">
						<DeleteIcon onClick={clear}/>
						</IconButton>
					}
					<Typography>{file?file:amazonDZ.isDragActive?"Suelta el archivo ...":"Arrastra o selecciona el archivo fuente"}</Typography>
				</Box>


				<Box sx={{display:warehouse && vendor=='mercado'?'block':'none'}} {...mercadoDZ.getRootProps()}>
					<input {...mercadoDZ.getInputProps()} />
					{file && 
						<IconButton sx={{position: 'absolute', top:0, right:0}} tooltip="Quitar archivo">
						<DeleteIcon onClick={clear}/>
						</IconButton>
					}
					<Typography>{file?file:mercadoDZ.isDragActive?"Suelta el archivo ...":"Arrastra o selecciona el archivo fuente"}</Typography>
				</Box>
				<Button disabled={!file || disabled} onClick={submitFile} variant="contained" color="primary">
					{disabled?<CircularProgress size={27}/>:'Registrar envío a canal de venta'}
				</Button>
			</Paper>
			
		</div>
	)
}

export default SalesChannelsShippments
